<!--
 * @Description: 
 * @Date: 2020-11-16 13:39:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:39:05
-->
<template>
  <g name="text" class="text">
    <path v-if="pointPath" :d="pointPath" fill="rgba(255,255,255,.4)" />
    <line
      v-if="pointPath"
      :x1="point[0]"
      :y1="point[1]"
      :x2="point[0]"
      :y2="getPointY"
      stroke="#E6EDFF"
      stroke-width="1"
    />
    <line
      :x1="point[0]"
      :y1="getPointY"
      :x2="getPointX"
      :y2="getPointY"
      stroke="#E6EDFF"
      stroke-width="1"
    />
    <circle
      :cx="getPointX - 5"
      :cy="getTextY - 5"
      r="2"
      stroke-width="0"
      :fill="icon"
    />
    <text class="t" :x="getPointX" :y="getTextY" fill="#666">{{ label }}</text>
  </g>
</template>

<script>
export default {
  props: {
    series0data: {
      type: Array,
      default: () => []
    },
    pointPath: {
      type: String,
      default: ''
    },
    point: {
      type: Array,
      default: () => [0, 0]
    },
    a: {
      type: Number,
      default: 0
    },
    b: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    label: {
      type: [Number, String],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    length() {
      return this.series0data.length;
    },
    getPointX() {
      const { point, b, pointPath } = this;
      if (!pointPath) {
        return point[0] + b - 10;
      }
      return 300;
    },
    getPointY() {
      const { point, b, index, pointPath } = this;
      // const y = -b / 2 - index * 24 + 50;
      if (!pointPath) {
        return point[1] + 10;
      }
      // if (y > point[1]) {
      //   return y - b;
      // }
      return -b + index * 30;
    },
    getTextY() {
      const { getPointY, pointPath } = this;
      if (!pointPath) {
        return getPointY + 5;
      }
      return getPointY + 5;
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.text {
  .t {
    font-size: 12px;
  }
}
</style>
